if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./build/component/hot.prod');
} else {
  module.exports = require('./build/component/hot.dev');
}
